import { render, staticRenderFns } from "./sjgl.vue?vue&type=template&id=bdd4cb26&scoped=true&"
import script from "./sjgl.vue?vue&type=script&lang=js&"
export * from "./sjgl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd4cb26",
  null
  
)

export default component.exports